import React, { Component } from 'react';
import Iframe from 'react-iframe'

class MemberInfo extends Component {
  render() {
    return (
      <section>
        <header id="page-title">
          <div className="container">
            <h1>Member Info</h1>
          </div>
        </header>
        <section className="container">

          <Iframe url="https://crckingston.elvanto.com.au/form/4aa7b27c-3668-11e5-9d36-06ba798128be/" width="100%" height="1575px" position="relative" />

        </section>
      </section>
    );
  }
}

export default MemberInfo;
